var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfileFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37.022,
    viewBox: "0 0 37 37.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#fff;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.522)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.593,16.546a12.378,12.378,0,0,0-2.6-4.873,84.21,84.21,0,0,0-7.165-7.337q-.606-.549-1.218-1.085c-.257-.224-.521-.435-.791-.637A13.33,13.33,0,0,0,13.643.188q-.586.1-1.17.25A12.806,12.806,0,0,0,3.463,8.73,103.534,103.534,0,0,0,.5,19.763c-.085.4-.17.794-.251,1.2-.078.381-.136.765-.177,1.147q-.042.388-.059.776A12.07,12.07,0,0,0,.04,24.427a12.212,12.212,0,0,0,3.232,7.3A13.232,13.232,0,0,0,13,36a13.638,13.638,0,0,0,4.155-.653c2.759-.883,5.53-1.876,8.271-2.961q1.084-.425,2.16-.88c.2-.082.4-.164.6-.248a13.512,13.512,0,0,0,1.892-.983,12.49,12.49,0,0,0,5.9-9.928A12.009,12.009,0,0,0,35.593,16.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.009,19.946c2.226,0,4.7-2.656,4.7-6.466,0-3.05-1.922-5.184-4.7-5.184s-4.7,2.134-4.7,5.184C12.305,17.29,14.782,19.946,17.009,19.946Zm0-10.685c2.242,0,3.742,1.694,3.742,4.222,0,2.826-1.82,5.5-3.742,5.5s-3.743-2.676-3.743-5.505C13.266,10.955,14.766,9.261,17.009,9.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.628,19.078a.481.481,0,1,0,0,.961,4.573,4.573,0,0,1,3.665,1.39,5.513,5.513,0,0,1,1.051,3.736H8.683a5.5,5.5,0,0,1,1.041-3.736,4.592,4.592,0,0,1,3.666-1.39.481.481,0,0,0,0-.961,5.49,5.49,0,0,0-4.4,1.73A6.687,6.687,0,0,0,7.77,25.719l.064.407H26.183l.064-.407a6.669,6.669,0,0,0-1.22-4.911A5.493,5.493,0,0,0,20.628,19.078Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileFill);
export default __webpack_public_path__ + "static/media/Icon-Profile-Fill.d070972b1d7c5567b392f16e79e0597c.svg";
export { ForwardRef as ReactComponent };